<template>
<div>

  <section>
    <div class="row pb-3 bg_azul_topo ">
      <div class="col-4 text_11 text_branco">
        <div style="margin-bottom:12px;"><span class="text_bold">Id da Conta:</span> <span class="text_verde">{{user.id}}</span> </div>
        <div class="text_branco"> {{user.email}} </div>
      </div>
      <div class="col-4 text_branco">
        <div class="text_13 text-center">Saldo de jogo </div>
        <div class="text_16 text_bold text_verde text-center">R$ {{ formatarMoeda(user.balance) }} </div>
      </div>
      <div class="col-4 text_branco">
        <div class="text_13 text-center">Saldo Convidado </div>
        <div class="text_16 text_bold text_verde text-center">R$ {{ formatarMoeda(user.balance_convidado) }} </div>
      </div>
    </div>
  </section>

  <section class="mb-4">
    <div class="row mb-3 pb-2 bg_azul_topo">
      <div class="col-6 text_18 text_bold text_cinza"> {{titulo}} </div>
      <div class="col-6 text_12 text-end text_verde">
        <router-link to="/conta/resumo" class="btn btn-success w-100 btn-sm mb-3">
          <img :src='"../../assets/image/seta_left.svg"' alt="Responsive image" width="18px"> &nbsp; VOLTAR
        </router-link>
      </div>
    </div>
  </section>

</div>
</template>

<script>

export default {

  props: {
    titulo: null,
  },

  data () {
    return {
      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],
    }
  },

  created(){
    localStorage.setItem("base_url_api_mobile", this.base_url_api)
  },

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"))
    if (a == null){ this.user = {} }else{ this.user = a }
  },
}

</script>

<style scoped>
  .btn-success{
    background-color: #5CB70D;
    color: #000;
  }
</style>


// WEBPACK FOOTER //
// src/components/conta/topo.vue